import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    createInTimeWork: () => {
        return HTTP.post('/work_time/create',null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    inTimeWorkList: () => {
        return HTTP.get('/work_time/workTimeIn', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    startWork: (id,data) => {
        return HTTP.post('/work_time/workTimeInUpdate/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}